/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Switch, Redirect, NavLink } from 'react-router-dom';

import moment from 'moment';

import { MdRadio, MdTv, MdRefresh } from 'react-icons/md';

import Spinner from '../Spinner';

import Store from './model/ChannelStore';

import { Calendar } from './Calendar';

const TypeToIcon = (type) => {
    switch (type) {
        case 'radio':
            return <MdRadio />;
        case 'tv':
            return <MdTv />;
        default:
            return type;
    }
};

@inject('auth')
@observer
class ChannelDetails extends Component {
    @observable store = Store.fromJS(this.props.auth, []);

    componentDidMount = () => {
        const { match } = this.props;
        this.store.date = moment().startOf('month');
        this.store.type = match.params.type;
        this.fetchData(match.params.id);
        // TODO sync asset updates
        // this.assetsStore.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        const { match } = this.props;
        if (nextProps.match.params.id !== match.params.id) {
            // Id changes
            this.fetchData(nextProps.match.params.id);
        }
        if (nextProps.match.params.date !== match.params.date) {
            this.store.date = moment(nextProps.match.params.date).startOf('month');
            this.fetchData(nextProps.match.params.id);
        }
    };

    componentWillUnmount = () => {
        // this.assetsStore.unsyncUpdates();
    };

    fetchData = (id) => {
        this.store.fetchChannel(
            id,
            this.store.date.format('YYYY-MM-DD'),
            this.store.date
                .clone()
                .endOf('month')
                .format('YYYY-MM-DD'),
        );
    };

    reload = () => {
        const { match } = this.props;
        // this.store.fetchTimelines(match.params.id);
    };

    previousMonth = () => {
        this.store.date = this.store.date.clone().add(-1, 'month');
        this.fetchData(this.props.match.params.id);
    };

    nextMonth = () => {
        this.store.date = this.store.date.clone().add(1, 'month');
        this.fetchData(this.props.match.params.id);
    };

    render() {
        const { channel, timelinesPlayout, timelinesSchedule, fetchingTimelines } = this.store;
        const { match } = this.props;

        // Do not remove. Need to use timelines Data inside Component to force render on mobx
        console.log('Timeline Summray', timelinesPlayout.length, timelinesSchedule.length);

        if (!channel || !channel.id) {
            return <span>Loading...</span>;
        }

        const startDate = moment('2019-08-01');
        const endDate = startDate.clone().endOf('month');

        const dates = [];
        while (startDate.isSameOrBefore(endDate)) {
            dates.push(startDate.clone());
            startDate.add(1, 'day');
        }

        return (
            <section>
                <h1>
                    {TypeToIcon(channel.type)} {channel.name}
                </h1>

                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <table className="table table-sm table-striped">
                                <tbody>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Id"
                                                defaultMessage="Id"
                                            />
                                        </th>
                                        <td>
                                            <code>{channel.id}</code>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Type"
                                                defaultMessage="Type"
                                            />
                                        </th>
                                        <td>{channel.type}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <FormattedMessage
                                                id="Channels.Name"
                                                defaultMessage="Name"
                                            />
                                        </th>
                                        <td>{channel.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        {console.log(match.url)}
                        <NavLink
                            className="nav-link"
                            to={`/channels/details/${channel.id}/calendar/`}
                        >
                            Calendar
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            to={`/channels/details/${channel.id}/timelines/`}
                        >
                            Timelines
                        </NavLink>
                    </li>
                </ul>

                <Calendar
                    timelinesSchedule={timelinesSchedule}
                    timelinesPlayout={timelinesPlayout}
                    nextMonthCallback={this.nextMonth}
                    previousMonthCallback={this.previousMonth}
                    loading={fetchingTimelines}
                    scheduleLayerId={channel.settings.timelines.schedule_layer_id}
                    playlistLayerId={channel.settings.timelines.playlist_layer_id}
                />
            </section>
        );
    }
}

ChannelDetails.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(ChannelDetails);
